import { render, staticRenderFns } from "./station-add-or-update.vue?vue&type=template&id=0a7af47a&scoped=true"
import script from "./station-add-or-update.vue?vue&type=script&lang=js"
export * from "./station-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./station-add-or-update.vue?vue&type=style&index=0&id=0a7af47a&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7af47a",
  null
  
)

export default component.exports